const DIET_CATEGORY_INITIAL_STATE = {
  isLoading: false,
  error: undefined,
  data: undefined,
}

export default DIET_CATEGORY_INITIAL_STATE
